import classNames from 'classnames';
import React from 'react';

interface Props {
    color?: 'soft';
    size?: 'small';
    spacing?: 'half-margin';
}

const Paragraph: React.SFC<Props> = ({ children, color, size, spacing }) => {
    const classes = classNames('paragraph', {
        [`paragraph--${color}`]: color ? true : false,
        [`paragraph--${size}`]: size ? true : false,
        [`paragraph--${spacing}`]: spacing ? true : false,
    });

    return <p className={classes}>{children}</p>;
};

export default Paragraph;



// WEBPACK FOOTER //
// ./js/common/components/Paragraph.tsx